import {
  Bot,
  Building,
  Building2,
  Crosshair,
  Database,
  Factory,
  FolderOpen,
  GraduationCap,
  Headphones,
  Heart,
  Landmark,
  LifeBuoy,
  Link,
  MessageSquare,
  Network,
  Scale,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingCart,
  Users,
  Wrench,
} from 'lucide-react';

// Icon mapping for menu items (keys match `icon` in menus.js)
const iconMap = {
  Shield: Shield,
  Users: Users,
  Database: Database,
  ShieldAlert: ShieldAlert,
  Headphones: Headphones,
  Crosshair: Crosshair,
  FolderOpen: FolderOpen,
  Building: Building,
  Wrench: Wrench,
  Link: Link,
  MessageSquare: MessageSquare,
  LifeBuoy: LifeBuoy,
  Building2: Building2,
  Heart: Heart,
  GraduationCap: GraduationCap,
  Landmark: Landmark,
  Factory: Factory,
  ShoppingCart: ShoppingCart,
  Scale: Scale,
  ShieldCheck: ShieldCheck,
  Network: Network,
  Bot: Bot,
};

// Accent color per menu item name
const colorMap = {
  GRC: '#2973a3',
  IAM: '#10b981',
  CMDB: '#3b82f6',
  XDR: '#ef4444',
  'Service Desk': '#f59e0b',
  Pentest: '#f97316',
  Documents: '#8b5cf6',
  Business: '#6366f1',
  BCRP: '#0d9488',
  Implementation: '#2973a3',
  Integration: '#10b981',
  Advisory: '#f59e0b',
  Support: '#8b5cf6',
  'Financial Services': '#3b82f6',
  Healthcare: '#ef4444',
  Education: '#10b981',
  Government: '#8b5cf6',
  Manufacturing: '#f97316',
  Retail: '#ec4899',
  MSSP: '#0ea5e9',
  'BOSSS vs ServiceNow': '#2973a3',
  'BOSSS vs Splunk': '#f97316',
  'BOSSS vs CrowdStrike': '#ef4444',
  'BOSSS vs SailPoint': '#10b981',
  'BOSSS vs Archer': '#8b5cf6',
  'BOSSS vs Qualys': '#3b82f6',
  'AI Voice Agents': '#6366f1',
};

const DEFAULT_COLOR = '#2973a3';

// Tinted square tile with the item's lucide icon; shared by desktop flyouts and the mobile drawer.
export default function NavItemIcon({ icon, name, size = 44 }) {
  const IconComponent = icon ? iconMap[icon] : null;
  if (!IconComponent) {
    return null;
  }

  const color = colorMap[name] || DEFAULT_COLOR;

  return (
    <div
      aria-hidden="true"
      style={{
        flexShrink: 0,
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${Math.round(size * 0.23)}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: `${color}15`,
      }}
    >
      <IconComponent
        strokeWidth={2}
        style={{ color }}
        size={Math.round(size / 2)}
      />
    </div>
  );
}
